import { render, staticRenderFns } from "./ViewByNotification.vue?vue&type=template&id=6b352576"
import script from "./ViewByNotification.vue?vue&type=script&lang=js"
export * from "./ViewByNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports